<template lang="html">
  <div class="row track" v-if="showMap">
    <iframe v-if="!isOrderLoading && !isMapLoading"
            :src="trackUrl" :key="trackUrl" frameborder="0"
            style="border:0" width="100%" height="700px"
            title="GpsTrack"
    />
  </div>
</template>

<script>
import { mapType } from 'pando-constants';

export default {
  props: {
    order: {
      type: Object,
      default: () => {},
    },
    isOrderLoading: {
      type: Boolean,
      default: false,
    },
    isShipper: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showMap: {
      type: Boolean,
      default: false,
    },
    operator: {
      type: String,
      default: '',
    },
    consentStatus: {
      type: String,
      default: '',
    },
    isMapLoading: {
      type: Boolean,
      default: false,
    },
    mapConfig: {
      type: Object,
      default: () => {},
    },
    environmentVariables: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      data: null,
    };
  },
  created() {
    const TripId = !this.isOrderLoading &&
        this.order.flow.fasttag_tracking && this.order.flow.fasttag_tracking.trip_id;
    this.loadMap(TripId);
  },
  computed: {
    trackUrl() {
      return this.getUrl();
    },
  },
  methods: {
    loadMap(key) {
      this.$emit('loadMap', key);
    },
    getUrl() {
      let url = `${window.location.origin}/map`;
      if (this.mapConfig.type && this.mapConfig.type === mapType().HERE_MAP) {
        const apiKey = this.environmentVariables.hm_key;
        url = `${window.location.origin}/hereMap?apiKey=${apiKey}`;
      }
      return url;
    },
  },
};
</script>

<style lang="scss">
@import "~@common/styles-shipper/settings";
.track {
  //border: 1px solid #E8E8E8;
  &-map {
    display: inline-block;
    float: left;
    &-list {
      display: inline-block;
      ul {
        padding-left: 0;
        margin: 0;
        @extend %list-unstyled;
        li {
          padding: 10px;
          width: 140px;
          border-bottom: 1px solid #E8E8E8;
          text-align: left;
          a {
            font-size: 1.2rem;
            color: #6E6E6E;
            letter-spacing: 0.3px;
            text-decoration: none;
            &.active {
              color: #008AFF;
            }
          }
        }
      }
    }
  }
}
.error-container {
  padding: 20px;
  text-align: center;
}
</style>
